export default __webpack_public_path__ + "static/Metanoia_greek_rect-f96430beb125dab48d5a8b170bd5dbbc.png";